module.exports = __webpack_public_path__ + "img/166.e6266dc4.jpg";